import axios from 'axios';
import store from '@/store/store';
import { actions as _act } from '@/models/store.actions';
import { OrganizationAdditionalParamsModel } from '@/models/organisation.models';

export const organizationService = {
  get,
  updateName,
  changeAdditionalParams,
  getDep,
  saveDep,
  delDep,
  getRoles,
  saveRole,
  delRoles,
  getUsers,
  addUser,
  editUser,
  disconnectUsers,
  getMyOrgs,
  editMyOrg,
  addMyOrg,
  delMyOrg,
  getUserData,
  resendRegistrationCompletionLetter
};

let model = {
  get baseUrl() {
    return store.getters[_act.SETT_GET_APIURLGET];
  }
};

function extract(r) {
  return r.data;
}

async function get() {
  return axios.get(model.baseUrl + 'organization/get').then(extract);
}

async function updateName(sign) {
  return axios.put(model.baseUrl + 'organization/updatename', { sign }).then(extract);
}
async function changeAdditionalParams(dataChangeModel: OrganizationAdditionalParamsModel) {
  return axios.patch(model.baseUrl + 'organization/changeAdditionalParams', dataChangeModel).then(extract);
}

async function getDep() {
  return axios.get(model.baseUrl + 'organization/departmentsget').then(extract);
}

async function saveDep(id: number, parentId: number, nameUk: string, nameEn: string, nameRu: string) {
  return axios
    .put(model.baseUrl + 'organization/departmentsave', {
      id,
      parentId,
      nameUk,
      nameEn,
      nameRu
    })
    .then(extract);
}

async function delDep(id: number) {
  return axios.delete(model.baseUrl + 'organization/departmentdel/' + id).then(extract);
}

async function getRoles() {
  return axios.get(model.baseUrl + 'organization/rolesget').then(extract);
}

async function saveRole(id: number, name: string, permissions: any) {
  return axios.put(model.baseUrl + 'organization/rolesave', { id, name, permissions }).then(extract);
}

async function delRoles(ids: number[]) {
  return axios.delete(model.baseUrl + 'organization/rolesdel', { data: ids }).then(extract);
}

async function getUsers() {
  return axios.get(model.baseUrl + 'organization/usersget').then(extract);
}

async function addUser(user: object) {
  return axios.put(model.baseUrl + 'organization/useradd', user).then(extract);
}

async function editUser(user: object) {
  return axios.patch(model.baseUrl + 'organization/useredit', user).then(extract);
}

async function disconnectUsers(userIds: number[], newAuthorUserCode: string) {
  return axios.patch(model.baseUrl + 'organization/usersdisconnect', { userIds, newAuthorUserCode }).then(extract);
}

async function getMyOrgs() {
  return axios.get(model.baseUrl + 'organization/getmyorganisations').then(extract);
}

async function editMyOrg(myOrganisation: object) {
  return axios.patch(model.baseUrl + 'organization/editmyorganisation', myOrganisation).then(extract);
}

async function addMyOrg(myOrganisation: object) {
  return axios.put(model.baseUrl + 'organization/addmyorganisation', myOrganisation).then(extract);
}

async function delMyOrg(ids: number[]) {
  return axios.delete(model.baseUrl + 'organization/delmyorganisation', { data: ids }).then(extract);
}

async function getUserData() {
  return axios.get(model.baseUrl + 'organization/userdataget').then(extract);
}

function resendRegistrationCompletionLetter(userCode: string): Promise<boolean> {
  return axios
    .post(`${model.baseUrl}organization/ResendRegistrationCompletionLetter/${userCode}`)
    .then(extract);
}
